import LgpdService from '@/services/admin/LgpdService'
import { ElMessageBox, ElNotification } from 'element-plus'

/**
 * Composable to check and prompt LGPD consent after login.
 * Extracted from LoginView to decouple LGPD logic from authentication flow.
 */
export async function useLgpdConsent(): Promise<boolean> {
  try {
    const consent = await LgpdService.verificarConsentimento()
    if (consent && consent.consentimentoDados) {
      return true
    }

    await ElMessageBox.confirm(
      'Para continuar utilizando o SisGel, voce precisa aceitar os termos de uso e a politica de privacidade. ' +
      'Seus dados serao tratados conforme a Lei Geral de Protecao de Dados (LGPD). ' +
      'Voce pode consultar a politica completa na secao Privacidade e Dados.',
      'Termos de Uso e Privacidade',
      {
        confirmButtonText: 'Aceito os Termos',
        cancelButtonText: 'Recusar',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false
      }
    )

    await LgpdService.registrarConsentimento({ consentimentoDados: true, consentimentoMarketing: false })
    return true
  } catch (err: unknown) {
    if (err === 'cancel') {
      ElNotification({ title: 'Aviso', message: 'Voce precisa aceitar os termos para usar o sistema.', type: 'warning' })
      return false
    }
    // If consent check fails (network etc), allow login anyway
    return true
  }
}
